<template>
    <div class="modal-goodslist">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">自选收费入住编辑</div>
                <button type="button" class="btn-close" @click="closeSelf">关闭</button>
            </div>
            <div class="modal-body">

                <el-form :model="editForm" :rules="rules" ref="editForm">
                    <div>
                        <el-card class="box-card" shadow='never'>
                            <div slot="header" class="clearfix"> <span>基本信息</span> </div>
                            <el-row>
                                <el-col :span="12" class="item">
                                    <el-form-item label="床号" required prop="berthCode">
                                        <el-cascader
                                            v-model="editForm.berthCode"
                                            placeholder="请选择床号"
                                            :options="ListBerth" :props="props" @change="handleChange" style="width:100%"></el-cascader>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" class="item">
                                    <el-form-item label="护理等级" required prop="nursingLevelCode">
                                        <el-select @change='nursingChange' v-model="editForm.nursingLevelCode" placeholder="请选择护理等级" style="width:100%">
                                            <el-option
                                                v-for="item in nursingLevelValue"
                                                :key="item.nursingLevelCode"
                                                :label="item.name"
                                                :value="item.nursingLevelCode">
                                                <span style="float: left">{{ item.name }}</span>
                                                <span style="float: right; color: #8492a6; font-size: 13px">{{ item.priceMonth }}元/月</span>
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12" class="item">
                                    <el-form-item label="入住收费项目" required>
                                        <template>
                                            <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
                                            <div style="margin: 15px 0;"></div>
                                            <el-checkbox-group v-model="institutionfeeArr" @change="handlefeeArrChange">
                                                <el-checkbox v-for="item in checkFeeValue" :label="item" :key="item">
                                                    <span>{{item}}</span>
                                                    <span v-for="i in institutionFeeList" :key="i">
                                                        <span v-if="item==i.name"> {{i.priceMonth}}元/月</span>
                                                    </span>
                                                </el-checkbox>
                                            </el-checkbox-group>
                                        </template>
                                    </el-form-item>
                            </el-col>
                                <el-col :span="12" class="item">
                                    <el-form-item label="入住类型" required prop="type">
                                        <el-select v-model="editForm.type" :disabled="isCheckin" placeholder="请选择入住类型" style="width:100%">
                                            <el-option
                                                v-for="(item,i) in typeValue"
                                                :key="i"
                                                :label="item"
                                                :value="i">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12" class="item">
                                    <el-form-item label="预计入住时间" required prop="beginTimePlan">
                                        <el-date-picker
                                            v-model="editForm.beginTimePlan"
                                            type="date"
                                            style="width:100%;"
                                            value-format="yyyy-MM-dd"
                                            placeholder="预计入住时间">
                                        </el-date-picker>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" class="item">
                                    <el-form-item label="预计退住时间" required prop="endTimePlan">
                                        <el-date-picker
                                            v-model="editForm.endTimePlan"
                                            type="date"
                                            style="width:100%;"
                                            value-format="yyyy-MM-dd"
                                            placeholder="预计退住时间">
                                        </el-date-picker>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-card>
                        <el-card class="box-card" shadow='never'>
                            <div slot="header" class="clearfix"> <span>折扣</span> </div>
                            <el-row>
                                <el-col :span="12" class="item">
                                    <el-form-item label="床位折扣">
                                        <span style="color:red;">{{roomTypePrice}}*{{editForm.roomDiscount}}%={{(roomTypeDiscountPrice/10000).toFixed(2)}}元/{{chargeType}}</span>
                                        <el-select @change="discountChange('room')" v-model="editForm.roomDiscount" placeholder="请选择床位折扣" style="width:100%">
                                            <el-option
                                                v-for="(item,i) in roomDiscountValue"
                                                :key="i"
                                                :label="item.name"
                                                :value="item.discount">
                                                <!-- <span style="float: left">{{ item.name }}</span>
                                                <span style="float: right; color: #8492a6; font-size: 13px">{{ item.discount }}%</span> -->
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" class="item" v-if="editForm.roomDiscountCode!=initCode">
                                    <el-form-item label="床位折扣到期时间" required prop="roomDctTime">
                                        <el-date-picker
                                            v-model="editForm.roomDctTime"
                                            type="date"
                                            style="width:100%;"
                                            value-format="yyyy-MM-dd"
                                            placeholder="请选择折扣到期时间">
                                        </el-date-picker>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" class="item">
                                    <el-form-item label="护理等级折扣">
                                        <span style="color:red;">{{nursingLevelPrice}}*{{editForm.nursingDiscount}}%={{(nursingLevelDiscountPrice/10000).toFixed(2)}}元/{{chargeType}}</span>
                                        <el-select @change="discountChange('nursing')" v-model="editForm.nursingDiscount" placeholder="请选择护理等级折扣" style="width:100%">
                                            <el-option
                                                v-for="(item,i) in nursingDiscountValue"
                                                :key="i"
                                                :label="item.name"
                                                :value="item.discount">
                                                <!-- <span style="float: left">{{ item.name }}</span>
                                                <span style="float: right; color: #8492a6; font-size: 13px">{{ item.discount }}</span> -->
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" class="item" v-if="editForm.nursingDiscountCode!=initCode">
                                    <el-form-item label="护理折扣到期时间" required prop="nursingDctTime">
                                        <el-date-picker
                                            v-model="editForm.nursingDctTime"
                                            type="date"
                                            style="width:100%;"
                                            value-format="yyyy-MM-dd"
                                            placeholder="请选择折扣到期时间">
                                        </el-date-picker>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" class="item">
                                    <el-form-item label="自选收费项目折扣">
                                        <span style="color:red;">{{otherPrice}}*{{editForm.otherDiscount}}%={{(otherDiscountPrice/10000).toFixed(2)}}元/{{chargeType}}</span>
                                        <el-select @change="discountChange('other')" v-model="editForm.otherDiscount" placeholder="请选择自选收费项目折扣" style="width:100%">
                                            <el-option
                                                v-for="(item,i) in otherDiscountValue"
                                                :key="i"
                                                :label="item.name"
                                                :value="item.discount">
                                                <!-- <span style="float: left">{{ item.name }}</span>
                                                <span style="float: right; color: #8492a6; font-size: 13px">{{ item.discount }}%</span> -->
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" class="item" v-if="editForm.otherDiscountCode!=initCode">
                                    <el-form-item label="自选收费折扣到期时间" required prop="otherDctTime">
                                        <el-date-picker
                                            v-model="editForm.otherDctTime"
                                            type="date"
                                            style="width:100%;"
                                            value-format="yyyy-MM-dd"
                                            placeholder="请选择折扣到期时间">
                                        </el-date-picker>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" class="item">
                                    <el-form-item label="总费用折扣">
                                        <span style="color:red;">{{sumPrice/10000}}*{{editForm.allDiscount}}%={{(sumPrice*(editForm.allDiscount*100)/100000000).toFixed(2)}}元/{{chargeType}}</span>
                                        <el-select @change="discountChange('all')" v-model="editForm.allDiscount" placeholder="请选择总费用折扣" style="width:100%">
                                            <el-option
                                                v-for="(item,i) in allDiscountValue"
                                                :key="i"
                                                :label="item.name"
                                                :value="item.discount">
                                                <!-- <span style="float: left">{{ item.name }}</span>
                                                <span style="float: right; color: #8492a6; font-size: 13px">{{ item.discount }}%</span> -->
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" class="item" v-if="editForm.allDiscountCode!=initCode">
                                    <el-form-item label="总费用折扣到期时间" required prop="allDctTime">
                                        <el-date-picker
                                            v-model="editForm.allDctTime"
                                            type="date"
                                            style="width:100%;"
                                            value-format="yyyy-MM-dd"
                                            placeholder="请选择折扣到期时间">
                                        </el-date-picker>
                                    </el-form-item>
                                </el-col>
                                <!-- <el-col :span="12" class="item" v-if="editForm.allDiscountCode!=initCode||editForm.roomDiscountCode!=initCode||editForm.nursingDiscountCode!=initCode||editForm.otherDiscountCode!=initCode">
                                    <el-form-item label="折扣到期时间" required prop="deductionEndTime">
                                        <el-date-picker
                                            v-model="editForm.deductionEndTime"
                                            type="date"
                                            style="width:100%;"
                                            value-format="yyyy-MM-dd"
                                            placeholder="请选择折扣到期时间">
                                        </el-date-picker>
                                    </el-form-item>
                                </el-col> -->
                            </el-row>
                        </el-card>
                        <el-card class="box-card" shadow='never' :body-style="{'padding-top':'40px'}">
                            <div slot="header" class="clearfix"> <span>优惠券</span> 
                                <el-button style="float: right; padding: 3px 0" @click="addDomain" type="text">添加</el-button>
                            </div>
                            <div v-if="editForm.couponList.length>0">
                                <el-row v-for='(item,index) in editForm.couponList' :key="index" :gutter="30">
                                    <el-col :span="10">
                                        <el-form-item label="优惠券" label-width="80px" :prop="'couponList.'+index+'.couponCode'" :rules="{
                                            required: true, message: '请选择优惠券', trigger: 'blur'}">
                                            <el-select v-model="item.couponCode" @change="getCouponMoney(index)" placeholder="请选择优惠券" style="width:100%">
                                                <el-option
                                                    v-for="(item,i) in couponValue"
                                                    :key="i"
                                                    :label="item.name"
                                                    :value="item.couponCode">
                                                    <span style="float: left">{{ item.name }}</span>
                                                    <span style="float: right; color: #8492a6; font-size: 13px">{{ item.money }}元</span>
                                                </el-option>
                                            </el-select>
                                            <!-- <el-input v-model="item.couponCode"  placeholder="请选择优惠券"></el-input> -->
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="10">
                                        <el-form-item label="优惠到期时间"  label-width="120px" required :prop="'couponList.'+index+'.endTime'" :rules="{
                                            required: true, message: '请选择优惠到期时间', trigger: 'blur'}">
                                            <el-date-picker
                                                v-model="item.endTime"
                                                type="date"
                                                style="width:100%;"
                                                value-format="yyyy-MM-dd"
                                                placeholder="请选择优惠到期时间">
                                            </el-date-picker>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="4">
                                        <el-button @click.prevent="removeDomain(item,index)">删除</el-button>
                                    </el-col>
                                </el-row>
                            </div>
                            <div v-else class="couponKong">
                                <span>暂未添加优惠券~</span>
                            </div>
                        </el-card>
                        <el-card class="box-card" shadow='never' :body-style="{'padding-bottom':'0px'}">
                            <div slot="header" class="clearfix"> <span>备注</span> </div>
                        <el-row>
                            <el-col :span="24" class="item">
                                <el-form-item prop="remarks">
                                    <el-input v-model="editForm.remarks" placeholder="请输入备注" rows="5" type="textarea"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        </el-card>
                    </div>

                </el-form>

            </div>
            <div class="modal-footer">
                <span class="totalPrices">参考总价：{{sumDiscountPrice}} 元/月</span>
                <el-button :loading="loading" type="primary" @click="confirm('editForm')">编辑</el-button>
            </div>
        </div>
    </div>
</template>

<script>

    import {timeStr,timefilters} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode,getChargeTime} from "@/utils/auth";

    var feeOptions = [];
    export default {
        name: 'Add',
        data() {
            return {
                checkAll: false,
                isCheckin: false,
                institutionfeeArr: [],
                checkinAutomatchFeeRelList: [],
                checkFeeValue: feeOptions,
                isIndeterminate: true,
                chargeType:'',
                noDiscount:{},//无折扣
                initCode:'00000000-0000-0000-0000-000000000000',
                roomDiscountValue:[],//房间折扣列表
                
                nursingDiscountValue:[],//护理等级折扣列表
                
                otherDiscountValue:[],//其他折扣列表
                
                allDiscountValue:[],//总费用折扣列表
                nursingLevelValue:[],
                couponValue:[],//
                
                roomTypePrice:0,//房间类型价格
                roomTypeDiscountPrice:0,//房间类型折后价格
                nursingLevelPrice:0,//护理等级价格
                nursingLevelDiscountPrice:0,//护理等级折后价格
                otherPrice:0,//自选项目价格
                otherDiscountPrice:0,//自选项目折后价格
                sumPrice:0,//总费用
                sumDiscountPrice:0,//折后总费用
                needVerify:0,//0不需要审核，1需要审核
                ListBerth:[],
                loading: false,
                typeValue:['正式入住','试住','预约入住'],
                roomTypeValue:['单人间','双人间'],
                props: {
                    emitPath:false,
                    value: 'value',
                    label: 'label',
                    // 子层级字段名
                    children: 'children'
                },
                preferentialPrice:[],
                editForm:{
                    timeStr:timeStr,
                    sign:'',
                    staffCode:getStaffCode(),
                    elderlyCode:'',
                    berthCode:'',
                    nursingLevelCode:'',
                    type:'',
                    beginTimePlan:'',
                    endTimePlan:'',
                    remarks:'',
                    // deductionEndTime:'',
                    feeArr:[],
                    roomDiscountCode:'',
                    nursingDiscountCode:'',
                    otherDiscountCode:'',
                    allDctTime:'',
                    otherDctTime:'',
                    roomDctTime:'',
                    nursingDctTime:'',
                    allDiscountCode:'',
                    allDiscount:100,//总费用折扣值
                    otherDiscount:100,//其他折扣值
                    nursingDiscount:100,//护理等级折扣值
                    roomDiscount:100,//房间折扣值
                    couponList:[],
                },
                // pickerOption: {
                //     disabledDate(time) {
                //         return time.getTime() < Date.now() - 8.64e7;
                //     },
                // },
                rules:{
                    berthCode:[
                        { required: true, message: '请选择床号', trigger: 'blur' },
                    ],
                    nursingLevelCode:[
                        { required: true, message: '请选择护理等级', trigger: 'blur' },
                    ],
                    beginTimePlan:[
                        { required: true, message: '请选择预计入住时间', trigger: 'blur' },
                    ],
                    endTimePlan:[
                        { required: true, message: '请选择预计退住时间', trigger: 'blur' },
                    ],
                    preferentialPrice:[
                        { required: true, message: '请选择优惠金额', trigger: 'blur' },
                    ],
                    preferentialEndTime:[
                        { required: true, message: '请选择优惠到期时间', trigger: 'blur' },
                    ],
                    // deductionEndTime:[
                    //     { required: true, message: '请选择折扣到期时间', trigger: 'blur' },
                    // ],
                    allDctTime:[
                        { required: true, message: '请选择折扣到期时间', trigger: 'blur' },
                    ],
                    otherDctTime:[
                        { required: true, message: '请选择折扣到期时间', trigger: 'blur' },
                    ],
                    roomDctTime:[
                        { required: true, message: '请选择折扣到期时间', trigger: 'blur' },
                    ],
                    nursingDctTime:[
                        { required: true, message: '请选择折扣到期时间', trigger: 'blur' },
                    ],
                    type:[
                        { required: true, message: '请选择入住类型', trigger: 'blur' },
                    ],
                    price:[
                        { required: true, message: '请输入实际入住价格', trigger: 'blur' },
                    ],

                }


            }
        },

        methods: {
            init(row){
                // this.$refs.editForm.resetFields()
                this.editForm.couponList=[];
                this.institutionFeeList = [];
                this.preferentialPrice=[]
                this.editForm.allDiscount=100
                this.editForm.roomDiscount=100
                this.editForm.nursingDiscount=100
                this.editForm.otherDiscount=100
                this.editForm.elderlyCode=row.elderlyCode;
                this.editForm.preferentialPrice = row.preferentialPrice;
                this.editForm.preferentialEndTime = row.preferentialEndTime;
                this.editForm.remarks = row.remarks;
                this.isCheckin=row.status==1?true:false
                // if(row.deductionEndTime){
                //     this.editForm.deductionEndTime = timefilters(row.deductionEndTime).slice(0,10);
                // }
                this.editForm.beginTimePlan = row.beginTimePlan;
                this.editForm.endTimePlan = row.endTimePlan;
                this.editForm.type=row.type;
                this.editForm.checkinCode=row.checkinCode;
                this.editForm.berthCode=row.berthCode;
                this.editForm.price = row.price;
                this.editForm.nursingLevelCode = row.checkinAutomatchDTO.nursingLevelCode;
                this.nursingLevelPrice = row.checkinAutomatchDTO.nursingLevelPriceMonth;
                this.roomTypePrice = row.checkinAutomatchDTO.roomTypePriceMonth;
                this.otherPrice = row.checkinAutomatchDTO.automatchPrice;

                this.checkinAutomatchFeeRelList = row.checkinAutomatchDTO.checkinAutomatchFeeRelList;
                //获取折扣信息
                let checkinAutoDiscountList = row.checkinAutoDiscountList;
                this.editForm.roomDiscountCode=this.initCode
                this.editForm.nursingDiscountCode=this.initCode
                this.editForm.otherDiscountCode=this.initCode
                this.editForm.allDiscountCode=this.initCode
                for(let i=0;i<checkinAutoDiscountList.length;i++){
                    var type=checkinAutoDiscountList[i].discountType
                    this.editForm[type+'DiscountCode'] =checkinAutoDiscountList[i].institutionDiscountCode;
                    this.editForm[type+'Discount'] = checkinAutoDiscountList[i].discount/100;
                    this.editForm[type+'DctTime']=timefilters(checkinAutoDiscountList[i].endTime).slice(0,10);
                }
                let checkinCouponList=row.checkinCouponList;
                checkinCouponList.forEach(element => {
                    this.editForm.couponList.push({
                        couponCode: element.couponCode,
                        endTime: timefilters(element.endTime).slice(0,10),
                        money:element.couponMoney
                    })
                    this.preferentialPrice.push(element.couponMoney)
                });
                this.sumPrice = 0;
                this.editForm.feeArr = [];
                this.feeOptions = [];
                this.institutionfeeArr = [];
                this.checkAll = false;

                // this.editForm.couponList.push({})

                this.getPriceByBerthCode(this.editForm.berthCode);
                this.nursingChange();
                this.getDiscount("room");
                this.getDiscount("nursing");
                this.getDiscount("other");
                this.getDiscount("all");
               
                this.getDiscountSumPrice();
                this.chargeType = getChargeTime();
                this.getListBerthValue(1);
                this.getNursingLevelList();
                this.getFeeList();
                this.getCouponList();
                this.noDiscount = {
                    institutionDiscountCode:this.initCode,discount:100,name:"无折扣"
                };
            },
            //优惠券添加
            addDomain() {
                if(this.couponValue.length==0){
                    return this.$message.error('暂无优惠券可添加！')
                }
                this.editForm.couponList.push({
                    couponCode: '',
                    endTime: '',
                    money:''
                });
            },
            //优惠券删除
            removeDomain(item,index) {
                this.editForm.couponList.splice(index, 1)
                this.preferentialPrice.splice(index, 1)
                this.getDiscountSumPrice();
            },
            //选优惠券时获取优惠金额
            getCouponMoney(index){
                var code=this.editForm.couponList[index].couponCode
                var data=this.couponValue.filter((value)=>{
                    return value.couponCode==code;
                })
                this.editForm.couponList[index].money=data[0].money
                this.preferentialPrice[index]=data[0].money
                this.getDiscountSumPrice();
            },
            discountChange(type){
                switch(type){
                    case "room":
                        this.editForm.roomDiscountCode =this.editForm.roomDiscount==100?this.initCode:this.roomDiscountValue[1].institutionDiscountCode;
                        break;
                    case "nursing":
                        this.editForm.nursingDiscountCode= this.editForm.nursingDiscount==100?this.initCode:this.nursingDiscountValue[1].institutionDiscountCode;
                        break;
                    case "other":
                        this.editForm.otherDiscountCode = this.editForm.otherDiscount==100?this.initCode:this.otherDiscountValue[1].institutionDiscountCode;
                        break;
                    case "all":
                        this.editForm.allDiscountCode = this.editForm.allDiscount==100?this.initCode:this.allDiscountValue[1].institutionDiscountCode;
                        break;
                }
                this.getDiscountSumPrice();
            },
            getCouponList(){
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"Coupon/List",
                    data: {
                        timeStr: timeStr,
                        sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
                        staffCode: getStaffCode(),
                        status:1
                    }
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            this.couponValue = response.data.data;
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }
                )
            },
            getNursingLevelList(){
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"NursingLevel/List",
                    data: {
                        timeStr: timeStr,
                        sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
                        staffCode: getStaffCode(),
                    }
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            this.nursingLevelValue = response.data.data;
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }
                )
            },
            getPriceByBerthCode(berthCode){
                this.advisePrice = 0;
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"RoomType/GetPriceByBerthCode",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode:getStaffCode(),
                        berthCode:berthCode
                    }
                }).then(
                    (response) => {
                        if (response.data.error == 0) {
                            this.roomTypePrice = response.data.data.priceMonth;
                            this.getSumPrice();
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }
                )
            },
            nursingChange(){
                for(let i=0;i<this.nursingLevelValue.length;i++){
                    if(this.editForm.nursingLevelCode==this.nursingLevelValue[i].nursingLevelCode){
                        this.nursingLevelPrice = this.nursingLevelValue[i].priceMonth;
                        break;
                    }
                }
                this.getSumPrice();
            },
            //获取折后总价
            getDiscountSumPrice(){
                this.roomTypeDiscountPrice = this.roomTypePrice*(this.editForm.roomDiscount*100);
                this.nursingLevelDiscountPrice = this.nursingLevelPrice*(this.editForm.nursingDiscount*100);
                this.otherDiscountPrice = this.otherPrice*(this.editForm.otherDiscount*100);
                this.sumPrice = this.roomTypeDiscountPrice + this.nursingLevelDiscountPrice + this.otherDiscountPrice;
                // console.log(this.sumPrice);
                // console.log(this.allDiscount);
                this.sumDiscountPrice = this.sumPrice*(this.editForm.allDiscount*100)
                var preferentialPrice1=0
                for(var i in this.preferentialPrice){
                    preferentialPrice1=(preferentialPrice1*100+this.preferentialPrice[i]*100)/100
                }
                this.sumDiscountPrice=((this.sumDiscountPrice-preferentialPrice1*100000000)/100000000).toFixed(2);
            },
            getDiscount(type){
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"InstitutionDiscount/GetListByDiscountType2",
                    data: {
                        timeStr: timeStr,
                        sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
                        staffCode: getStaffCode(),
                        discountType:type
                    }
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            let res = response.data.data;
                            // res.push(this.noDiscount);
                            var valueList=[]
                            valueList.push(this.noDiscount);
                            if(res){
                                for(var i=0;i<5;i++){
                                    var name=i>0?'discount'+(i+1):'discount'
                                    let discount=res[name]
                                    if(discount>0){
                                        var data={
                                            institutionDiscountCode:res.institutionDiscountCode,discount:discount/100,name:discount/100+'折'
                                        };
                                        valueList.push(data)
                                    }
                                }
                            }
                            if(type=='room'){
                                this.roomDiscountValue = valueList;
                            }else if(type=="nursing"){
                                this.nursingDiscountValue = valueList;
                            }else if(type == "other"){
                                this.otherDiscountValue = valueList;
                            }else if(type == "all"){
                                this.allDiscountValue = valueList;
                            }
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }
                )
            },
            handleChange(value) {
                this.editForm.price=null;
                this.GetPriceByBerthCode(value);
            },
            //全选checkBox
            handleCheckAllChange(val) {
                this.institutionfeeArr = val ? feeOptions : [];
                this.isIndeterminate = false;
                this.editForm.price=null;
                this.getSumPrice();
            },
            //单选checkBox
            handlefeeArrChange(value) {
                let checkedCount = value.length;
                this.checkAll = checkedCount === this.checkFeeValue.length;
                this.isIndeterminate = checkedCount > 0 && checkedCount < this.checkFeeValue.length;
                this.editForm.price=null;
                this.getSumPrice();
            },
            //获取总价格
            getSumPrice(){
                // if(this.roomTypePrice==0||this.roomTypePrice==null){
                //     this.$message('请选择床位');
                //     return;
                // }
                this.editForm.feeArr = [];
                this.otherPrice = 0;
                for(let i =0;i<this.institutionfeeArr.length;i++){
                    for(let j=0;j<this.institutionFeeList.length;j++){
                        if(this.institutionfeeArr[i]==this.institutionFeeList[j].name){
                            this.editForm.feeArr.push(this.institutionFeeList[j].institutionFeeCode);
                            this.otherPrice = this.otherPrice +this.institutionFeeList[j].priceMonth;
                        }
                    }
                }
                this.getDiscountSumPrice();
            },
            
            closeSelf() {
                this.$emit("closeZiXuanEdit");
            },
            //获取全部床位
            getListBerthValue(num){
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"Berth/ListAll",
                    data: {
                        timeStr: timeStr,
                        sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
                        staffCode: getStaffCode(),
                        berthCode:this.editForm.berthCode
                    }
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            if(num!=1){
                                this.editForm.berthCode=''
                            }
                            var datas=response.data.data
                            var JSONData=JSON.stringify(datas);
                            JSONData=JSONData.replace(/listRoomDTO/g,'children');
                            JSONData=JSONData.replace(/listBerth/g,'children');
                            JSONData=JSONData.replace(/name/g,'label');
                            JSONData=JSONData.replace(/number/g,'label');
                            var list=this.getListBerth(JSON.parse(JSONData),0)
                            JSONData=JSON.stringify(list);
                            JSONData=JSONData.replace(/buildingCode/g,'value');
                            JSONData=JSONData.replace(/roomCode/g,'value');
                            JSONData=JSONData.replace(/berthCode/g,'value');
                            this.ListBerth=JSON.parse(JSONData);
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }
                )
            },
            getListBerth(list,level){
                for(var i in list){
                    if(level==1){
                        list[i].buildingCode=list[i].roomCode
                    }
                    if(level==2){
                        list[i].roomCode=list[i].berthCode
                    }
                    if(level<2){
                        this.getListBerth(list[i].children,level+1)
                    }
                }
                return list;
            },
            //根据选择床位获取对应房间类型的价格
            GetPriceByBerthCode(berthCode){
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"RoomType/GetPriceByBerthCode",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode:getStaffCode(),
                        berthCode:berthCode
                    }
                }).then(
                    (response) => {
                        if (response.data.error == 0) {
                            this.roomTypePrice = response.data.data.priceMonth;
                            this.getSumPrice();
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }
                )
            },
            //获取机构参数
            getFeeList(){
                feeOptions.splice(0,feeOptions.length);
                this.institutionfeeArr = [];

                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"InstitutionFee/List",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode:getStaffCode(),
                        status:1
                    }
                }).then(
                    (response) => {
                        if (response.data.error == 0) {
                            let res = response.data.data
                            this.institutionFeeList = response.data.data;
                            for(let i =0;i<res.length;i++){
                               // feeOptions.push(res[i]);
                                feeOptions.push(res[i].name);
                                
                            }
                            for(let i=0;i<this.checkinAutomatchFeeRelList.length;i++){
                                this.institutionfeeArr.push(this.checkinAutomatchFeeRelList[i].institutionFeeName);
                            }
                            //重置checked
                            let checkedCount = this.checkinAutomatchFeeRelList.length;
                            this.checkAll = checkedCount === this.checkFeeValue.length;
                            this.isIndeterminate = checkedCount > 0 && checkedCount < this.checkFeeValue.length;
                            this.getSumPrice();

                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }
                )
            },
            confirm(editForm){
                this.$refs[editForm].validate((valid) => {
                    if(valid){
                        this.addSubmit();
                    }else {
                        this.$message.error('请完善信息')
                        return false;
                    }
                })

            },

            addSubmit(){
                if(this.loading){
                    return;
                }else{
                    this.loading = true;
                }

                this.editForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);
                // this.editForm.berthCode = this.editForm.berthCode[2]
                var editForm =JSON.parse(JSON.stringify(this.editForm))
                // if(editForm.allDiscountCode==this.initCode&&editForm.roomDiscountCode==this.initCode&&editForm.nursingDiscountCode==this.initCode&&editForm.otherDiscountCode==this.initCode){
                //     editForm.deductionEndTime=''
                // }else{
                //     editForm.allDiscount*=100
                //     editForm.roomDiscount*=100
                //     editForm.nursingDiscount*=100
                //     editForm.otherDiscount*=100
                // }
                editForm =this.submitBefore(editForm,'room');
                editForm =this.submitBefore(editForm,'nursing');
                editForm =this.submitBefore(editForm,'other');
                editForm =this.submitBefore(editForm,'all');
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"Checkin/EditAutoNew",
                    data: editForm
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            this.$emit("closeZiXuanEdit");
                            this.$emit("getList");
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }
                )
            },
            submitBefore(editForm,type){
                if(editForm[type+'DiscountCode']==this.initCode){
                    editForm[type+'DctTime']=''
                }else{
                    editForm[type+'Discount']*=100
                }
                return editForm
            }

        }
    }


</script>





<style lang="scss" scoped>

    .modal-goodslist {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0,0,0,.3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99;

        .modal {
            background-color: #fff;
            box-shadow:   0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
            overflow-x:auto;
            display: flex;
            flex-direction: column;
            border-radius: 10px;
            width: 1000px;

            .modal-header {
                border-bottom: 1px solid #eee;
                color: #313131;
                justify-content: space-between;
                padding: 10px;
                display: flex;
            }
            .modal-body {
                position: relative;
                padding: 20px;
                z-index: 99;
                height: 65vh;
                overflow-y:auto;
                .inputMoneyNumber /deep/ .el-input__inner{
                    text-align: left;
                }
                .box-card{
                    margin-bottom: 20px;
                }
                .couponKong{
                    display: flex;
                    justify-content: center;
                    color: #999;
                    margin-bottom: 20px;
                }
            }
            
            .modal-footer {
                border-top: 1px solid #eee;
                justify-content: flex-end;
                padding: 15px;
                display: flex;
                .totalPrices{
                    font-size: 20px;
                    color: #ff4400;
                    line-height: 40px;
                    margin-right: 20px;
                }
            }


        }

    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }


</style>
